// Список тем для выбора в настройках. label — ключ перевода. Цвета каждой темы заданы
// в styles/tokens/_palettes.scss под тем же id.
export const THEMES = [
  { id: 'gazprom', label: 'Theme Gazprom' },
  { id: 'theme-1', label: 'Theme Contracteum' },
  { id: 'theme-2', label: 'Theme Green' },
  { id: 'theme-3', label: 'Theme Graphite' },
  { id: 'theme-4', label: 'Theme Marine' },
  { id: 'theme-5', label: 'Theme Orange' },
  { id: 'theme-6', label: 'Theme Emerald' },
] as const;

export type ThemeId = (typeof THEMES)[number]['id'];

export const DEFAULT_THEME: ThemeId = 'gazprom';

export const THEME_STORAGE_KEY = 'selectedTheme';

export const isThemeId = (value: unknown): value is ThemeId =>
  THEMES.some((theme) => theme.id === value);
